import React, { useEffect, useState } from 'react'
import WizardInnerLeftMenuContent from './WizardInnerLeftMenuContent';
import WizardMenu from './WizardMenu';
import { Nav, NavItem, NavLink } from 'reactstrap'

const WizardInnerLeftMenu = (props) => {
   
    const { subCategKey,handleActiceSubTab } = { ...props }
    const MenuItems = WizardMenu();
    const [subCategItems, setSubCategItems] = useState([])
    const [tabList, setTabsList] = useState([])
    const [activeTab, setActiveTab] = useState()
    const [nextDisabled, setNextDisabled] = useState(false);
    const [prevDisabled, setPrevDisabled] = useState(false);
    useEffect(() => {
        const selected_Item_List = MenuItems.filter((item) => item.key === subCategKey);
        if (selected_Item_List && selected_Item_List.length > 0) {
            let subCategories = selected_Item_List[0].subCategoryItems
            setSubCategItems(subCategories)
            setActiveTab(subCategories[0].key)
            handleActiceSubTab(subCategories[0].key,selected_Item_List[0].name)
        }
    }, [subCategKey])
    const handleActiveTab = (item) => {
        const { key, name, right, component } = { ...item }
        let dynamicTabs = [...tabList]
        if (tabList.length === 0) {
            const activeTabElement = subCategItems.filter((item) => item.key === activeTab)
            const obj = {
                key: activeTabElement.key,
                name: activeTabElement.name,
                right: activeTabElement.right,
                component: activeTabElement.component,
            }
            dynamicTabs.push(obj)
        }
        const newTabObject = {
            key: key,
            name: name,
            right: right,
            component: component,
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        const selected_Item_List = MenuItems.filter((item) => item.key === subCategKey)
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            setTabsList(dynamicTabs)
        }
        if (activeTab !== key) {
            setActiveTab(key)
            handleActiceSubTab(key,selected_Item_List[0].name)
        }
    }
    const handleNextActiveTab = (activeTab) => {
        let nextActiveTab = activeTab + 1
        let nextActiveSubItem = subCategItems.filter((item) => item.key === nextActiveTab)
        if (nextActiveSubItem[0]) {
            handleActiveTab(nextActiveSubItem[0])
        }
    }
    const handlePrevActiveTab = (activeTab) => {
        let prevActiveTab = activeTab - 1
        let prevActiveSubItem = subCategItems.filter((item) => item.key === prevActiveTab)
        if (prevActiveSubItem[0]) {
            handleActiveTab(prevActiveSubItem[0])
        }
    }
    useEffect(() => {
        if (activeTab && subCategItems) {
            if (activeTab === subCategItems[0].key) {
                setPrevDisabled(true);
                if (nextDisabled) {
                    setNextDisabled(false);
                }
            }
            else if (activeTab === subCategItems[subCategItems?.length - 1].key) {
                setNextDisabled(true);
                if (prevDisabled) {
                    setPrevDisabled(false);
                }
            }
            else {
                setPrevDisabled(false);
                setNextDisabled(false);
            }
        }
    }, [activeTab])
    return (
        <>
            <div className="d-flex justify-content-between align-items-baseline my-3 mb-5 px-2">
                <button class={`btn btn-orange px-1 ${prevDisabled ? 'disable' : ''}`} onClick={() => handlePrevActiveTab(activeTab)}><i className="icon-arrow-left2 me-1"></i>Back Step</button>
                <div className="steps">
                    <Nav className='card-tabs'>
                        {subCategItems && subCategItems.map((item, index) => {
                            return (
                                <React.Fragment key={item.key}>
                                    {/* {item.isFilled === 'true' ? <i className="icon-Icon-awesome-check-circle mt-2 ms-1" style={{ color: 'var(--orangeBright)' }}></i> : ''} */}
                                    <NavItem onClick={() => handleActiveTab(item)}>
                                        <NavLink href="#" className={`${activeTab === item.key ? "py-1 in_progress " : "py-1"} ${item.isFilled === "true" ? 'completed' : ''}`}>
                                            {/* {item.isFilled === 'true' ? '' : <i className="icon-arrow-right"></i>} */}
                                            <div className={`position-relative ${index === subCategItems?.length - 1 ? "" : `${item.className}`}`}>
                                                <span className="heading sm">{index + 1}</span>
                                                <p className="heading mt-1">{item.name}</p>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                </React.Fragment>
                            )
                        })}
                    </Nav>
                </div>
                <button class={`btn btn-orange px-1 ${nextDisabled ? 'disable' : ''}`} onClick={() => handleNextActiveTab(activeTab)}>Next Step<i className="icon-arrow-right2 ms-1"></i></button>

            </div>
            <WizardInnerLeftMenuContent activeTab={activeTab}
                dynamicTabs={tabList}
                subCategItems={subCategItems}
            />
        </>
    )
}

export default WizardInnerLeftMenu
